<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      As we’ve seen in the last activity, one of the best ways to positively impact the environment
      is to lead by example. If you are going to work in a career that concerns itself with reducing
      the negative impact humans have on the environment, there’s no better place to start than with
      yourself.
    </p>
    <p class="mb-5">
      In the PDF below, you’ll find 100 steps you can take to reduce your impact on the environment.
      Read through this extensive list and choose ten steps you plan to implement over the next
      week.
    </p>

    <a :href="'content/envscience/100-Ways-to-Reduce-Your-Impact.pdf' | blob_url" target="_blank">
      <centered-image-wrapper
        alt="100 ways to reduce your impact (PDF) (opens in a new tab)"
        :image="require('@/assets/images/experiences/envscience/100_ways_button.png')"
      />
    </a>

    <p class="mb-5">
      In the first column, record the number of the step and its title. In the column to the right,
      record how you implemented this step.
    </p>

    <table class="table default-table">
      <tr class="header">
        <th scope="col" colspan="3">10 Ways to Reduce My Impact</th>
      </tr>
      <tr class="subheader">
        <th scope="col" width="5%"></th>
        <th scope="col" width="45%">Step</th>
        <th scope="col" width="50%">What I Did</th>
      </tr>
      <tr class="body" v-for="index in 10" :key="index">
        <td>{{ index }}.</td>
        <td><text-block v-model="data['question' + index + '_1']" :editable="isEditable" /></td>
        <td><text-block v-model="data['question' + index + '_2']" :editable="isEditable" /></td>
      </tr>
    </table>
    <p class="mb-5">
      It’s essential, where possible, to make each change permanent, a new way of doing things.
    </p>
    <p class="mb-5">
      To make something a habit, we must first make the conscious effort to do it repeatedly.
    </p>
    <p class="mb-5">
      Over time, this will form an unconscious habit and become just the way we do that thing. Once
      the ten steps on your list become a habit, add a few more steps to your repertoire and keep
      going!
    </p>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      popupActive: false,
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
